module.exports = __webpack_public_path__ + "static/media/bwTheme-boy.445fff8a.svg";